import React, { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";

export const useHasToken = () => {
  const { currentUser, logout } = useAuth();
  const hasLocalToken = JSON.parse(sessionStorage.getItem("userData") as string);

  useEffect(() => {
    const localToken = sessionStorage.getItem("userData");
    if (!currentUser && localToken) {
      logout();
    }
  }, [currentUser, hasLocalToken]);

  return currentUser || hasLocalToken;
};
